import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import tokens from '../../design/tokens'

export const TOOLTIPLABEL_VARIANT_DEFAULT = 'default'
export const TOOLTIPLABEL_VARIANT_SUCCESS = 'success'
export const TOOLTIPLABEL_VARIANT_ERROR = 'error'
export const TOOLTIPLABEL_VARIANT_NEUTRAL = 'neutral'

const handleVariant = ({ variant }) => {
  switch (variant) {
    case TOOLTIPLABEL_VARIANT_DEFAULT:
      return `
        background-color: var(--champagne);
        
        &::after {
          border-top-color: var(--champagne);
        }
        `
    case TOOLTIPLABEL_VARIANT_SUCCESS:
      return `
        background-color: var(--tea-green);

        &::after {
          border-top-color: var(--tea-green);
        }`
    case TOOLTIPLABEL_VARIANT_ERROR:
      return `
        background-color: var(--azalea);

        &::after {
          border-top-color: var(--azalea);
        }`
    case TOOLTIPLABEL_VARIANT_NEUTRAL:
        return `
        background-color: var(--silver);

        &::after {
          border-top-color: var(--silver);
        }`

  }
}

const StyledContainer = styled.div`
  position: relative;
  display: inline-block;
  padding: ${tokens.grid.gutterN / 2}px ${tokens.grid.gutterN}px;
  border-radius: ${tokens.borderRadius.small};
  font-weight: ${tokens.fontWeight.bold};
  font-size: ${tokens.fontSize.standard};
  ${handleVariant};

  &::after {
    position: absolute;
    display: block;
    content: '';
    right: ${tokens.grid.gutter};
    bottom: -${tokens.grid.gutterN / 2}px;

    border-bottom-width: 0;
    border-left: ${tokens.grid.gutterN / 2}px solid transparent;
    border-right: ${tokens.grid.gutterN / 2}px solid transparent;
    border-top-width: ${tokens.grid.gutterN / 2}px;
    border-style: solid;
  }
`

export const TooltipLabel = ({ className, children, variant }) => {
  return (
    <StyledContainer className={className} variant={variant}>
      {children}
    </StyledContainer>
  )
}

TooltipLabel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,

  variant: PropTypes.oneOf([
    TOOLTIPLABEL_VARIANT_DEFAULT,
    TOOLTIPLABEL_VARIANT_SUCCESS,
    TOOLTIPLABEL_VARIANT_ERROR,
    TOOLTIPLABEL_VARIANT_NEUTRAL
  ])
}

TooltipLabel.defaultProps = {
  variant: TOOLTIPLABEL_VARIANT_DEFAULT
}
